import { Trans } from '@lingui/macro';
import { useContext, useMemo, useState, useCallback } from 'react';
import { getTextColorClass, getColor } from '@utils/Utils';
import { BasicData } from '@App';
import { Swiper, SwiperSlide } from 'swiper/react';

import './style.scss';

const FastFactsComponent = () => {
    const { travellers, travellers_adult, travellers_children, days, reference_number, special_interests, theme, group_size } = useContext(BasicData);

    const [activeSlide, setActiveSlide] = useState('info');

    const colors = getColor(theme);

    const guests = travellers_adult + travellers_children;

    const slides = useMemo(() => {
        let arr = ['info'];
        if (travellers) {
            arr.push('travellers');
        }
        if (special_interests) {
            arr.push('special_interests');
        }
        return arr;
    }, [travellers, special_interests])

    const onSlideChange = useCallback(s => {
        setActiveSlide(slides[s.realIndex]);
    }, [slides])

    return (
        <div className={`trip-summary-fast-facts bg-white ${getTextColorClass(colors?.secondary)}`}>
            <div className="desktop">
                <div className="trip-summary-fast-facts-block info">
                    <i className="icon icon-info"></i>
                    <h4><Trans>Information</Trans></h4>
                    {guests > 0 && <p>{guests} {guests > 1 ? <Trans>Guests</Trans> : <Trans>Guest</Trans>}</p>}
                    <p className="break-words">{days} {days === 1 ? <Trans>Day</Trans> : <Trans>Days</Trans>} / {days - 1} {(days - 1) === 1 ? <Trans>Night</Trans> : <Trans>Nights</Trans>}</p>
                    {reference_number && <p><Trans>Reference No</Trans>: {reference_number}</p>}
                    {group_size && <p><Trans>Group Size</Trans>{group_size}</p>}
                </div>
                {special_interests && (
                    <div className="trip-summary-fast-facts-block">
                        <i className="icon icon-zap"></i>
                        <h4><Trans>Special Interests</Trans></h4>
                        <p className="break-words">
                            {special_interests?.map((interest, i) => (
                                <span key={i}> {i > 0 ? <i>•</i> : ''}{interest} </span>
                            ))}
                        </p>
                    </div>
                )}
                {travellers && (
                    <div className="trip-summary-fast-facts-block">
                        <i className="icon icon-users"></i>
                        <h4><Trans>Travellers</Trans></h4>
                        <p className="break-words">
                            {travellers?.map((traveller, i) => (
                                <span key={i}> {i > 0 ? <i>•</i> : ''}{traveller} </span>
                            ))}
                        </p>
                    </div>
                )}
            </div>
            <div className="mobile">
                <Swiper
                    spaceBetween={20}
                    slidesPerView={1.1}
                    centeredSlides
                    onSlideChange={onSlideChange}
                >
                    <SwiperSlide>
                        <div className="trip-summary-fast-facts-block">
                            <i className="icon icon-info"></i>
                            <h4><Trans>Information</Trans></h4>
                            {guests > 0 && <p>{guests} {guests > 1 ? <Trans>Guests</Trans> : <Trans>Guest</Trans>}</p>}
                            <p className="break-words">{days} {days === 1 ? <Trans>Day</Trans> : <Trans>Days</Trans>} / {days - 1} {(days - 1) === 1 ? <Trans>Night</Trans> : <Trans>Nights</Trans>}</p>
                            {reference_number && <p><Trans>Reference No</Trans>: {reference_number}</p>}
                            {group_size && (<p><Trans>Group Size</Trans>: {group_size}</p>)}
                        </div>
                    </SwiperSlide>
                    {special_interests && (
                        <SwiperSlide>
                            <div className="trip-summary-fast-facts-block">
                                <i className="icon icon-zap"></i>
                                <h4><Trans>Special Interests</Trans></h4>
                                <p className="break-words">
                                    {special_interests?.map((interest, i) => (
                                        <span key={i}> {i > 0 ? <i>•</i> : ''}{interest} </span>
                                    ))}
                                </p>
                            </div>
                        </SwiperSlide>
                    )}
                    {travellers && (
                        <SwiperSlide>
                            <div className="trip-summary-fast-facts-block">
                                <i className="icon icon-users"></i>
                                <h4><Trans>Travellers</Trans></h4>
                                <p className="break-words">
                                    {travellers?.map((traveller, i) => (
                                        <span key={i}> {i > 0 ? <i>•</i> : ''}{traveller} </span>
                                    ))}
                                </p>
                            </div>
                        </SwiperSlide>
                    )}
                </Swiper>
                {slides.length > 1 && (
                    <div className="slide-thumbs">
                        {slides.map(x => (
                            <div className={`slide-thumb${activeSlide === x ? ' active' : ''}`} key={x}></div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    )
}

export default FastFactsComponent;